import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import {
  Box,
  Button,
  Container,
  Card,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import Image from "../PatientsDasboard/Image";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";

const ReportIssueView = () => {
  const location = useLocation();
  const { id } = location.state || {}; // Extract the ID from the passed state

  // const { id } = useParams(); // Get the 'id' from the URL parameters
  const [formData, setFormData] = useState({
    id: "",
    u_id: "",
    u_role: "",
    issue_priority: "",
    issue_date: "",
    issue_status: "",
    issue_description: "",
    issue_upload: "",
    issue_dev_comment: "",
    issue_resolve_date: "",
  });

  // Fetch data from the API by using the 'id'
  useEffect(() => {
    // Adjust the URL to fetch the data for the specific 'id'
    fetch(`${process.env.REACT_APP_KAIZEN_API}/api/dev3/getreport/${id}`)
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          setFormData({
            id: data.id || "",
            u_id: data.u_id || "",
            u_role: data.u_role || "",
            issue_priority: data.issue_priority || "",
            issue_date: data.issue_date || "",
            issue_status: data.issue_status || "",
            issue_description: data.issue_description || "",
            issue_upload: data.issue_upload || "",
            issue_dev_comment: data.issue_dev_comment || "",
            issue_resolve_date: data.issue_resolve_date || "",
          });
        }
      })
      .catch((error) => console.error("Error:", error));
  }, [id]); // Re-fetch the data whenever the 'id' changes

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <>
      <Helmet>
        <title>View an Issue | Kaizen Digital</title>
      </Helmet>
      <Typography variant="h3" sx={{ mb: 0 }} color="primary">
        View Issue Status
      </Typography>

      <Card maxWidth="md" sx={{ mt: 4 }}>
        <Box m="20px">
          <Grid container spacing={2}>
            <Grid item xs={6} sm={3}>
              <TextField
                fullWidth
                label="User Role"
                name="u_role"
                variant="outlined"
                size="small"
                value={formData.u_role}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField
                fullWidth
                label="Priority"
                name="issue_priority"
                variant="outlined"
                size="small"
                value={formData.issue_priority}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField
                fullWidth
                label="Received Date"
                name="issue_date"
                variant="outlined"
                size="small"
                value={formData.issue_date}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField
                fullWidth
                label="Status"
                name="issue_status"
                variant="outlined"
                size="small"
                value={formData.issue_status}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Issue Description"
                name="issue_description"
                variant="outlined"
                multiline
                rows={4}
                value={formData.issue_description}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12}>
              <Image
                src={`${process.env.REACT_APP_KAIZEN_API}/api/dev3/${formData.issue_upload}`}
                alt="issue_upload"
                sx={{
                  width: "100%", // Adjust the width as per your requirement
                  height: "100%", // Or set a fixed height like '200px'
                  maxHeight: "400px", // You can limit the height if necessary
                  objectFit: "cover", // Ensures the image is scaled properly without distortion
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Developer's Comments"
                name="issue_dev_comment"
                variant="outlined"
                size="small"
                value={formData.issue_dev_comment}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Resolved Date"
                name="issue_resolve_date"
                variant="outlined"
                size="small"
                value={formData.issue_resolve_date}
                onChange={handleInputChange}
              />
            </Grid>
          </Grid>
        </Box>
      </Card>
    </>
  );
};

export default ReportIssueView;
